import { NgModule } from '@angular/core';
import { LoadHandoverComponent } from './load-handover.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { LOAD_HANDOVERS_ROUTES } from './load-handover.routes';
import { LoadHandoverService } from './shared/load-handover.service';
import { LoadHandoverMapComponent } from './load-handover-map/load-handover-map.component';


@NgModule({
    imports: [
        RouterModule.forChild(LOAD_HANDOVERS_ROUTES),
        SharedModule
    ],
  declarations: [
    LoadHandoverComponent,
    LoadHandoverMapComponent
  ],
  providers: [
    LoadHandoverService
  ]
})
export class LoadHandoverModule {
}
